export type Preferences = Record<PreferenceKey, string | null>;

export enum PreferenceKey {
    Username = 'username',
    School = 'school',
}
